import React, { useEffect } from "react";
import { Box, Button, TextField, Grid, Typography } from "@mui/material";
import Navbar from "../Navbar";
import "./ViewChallan.css";
import { useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import DownloadPage from "../DownloadPage";
import { Link, useNavigate, useParams } from "react-router-dom";

import logo from "./Geekay-logo.png";

function ViewChallan() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [productInput, setproduct] = useState([]);
  const [verticalInput, setverticalInput] = useState([]);
  const [itemDetails, setitemDetails] = useState([]);
  // console.log('data',verticalInput)

  const item1 = itemDetails.map((item) => {
    // return item.distin,item.sn,items.descriptive,items.test,items.pltonns,items.swltonns;
  return item.distin;
  });
  const item2 = itemDetails.map((item) => {
    // return item.distin,item.sn,items.descriptive,items.test,items.pltonns,items.swltonns;
  return item.sn;
  });
  const item3 = itemDetails.map((item) => {
    // return item.distin,item.sn,items.descriptive,items.test,items.pltonns,items.swltonns;
  return item.descriptive;
  });
  const item4 = itemDetails.map((item) => {
    // return item.distin,item.sn,items.descriptive,items.test,items.pltonns,items.swltonns;
  return item.test;
  });
  const item5 = itemDetails.map((item) => {
    // return item.distin,item.sn,items.descriptive,items.test,items.pltonns,items.swltonns;
  return item.pltonns;
  });
  const item6 = itemDetails.map((item) => {
    // return item.distin,item.sn,items.descriptive,items.test,items.pltonns,items.swltonns;
  return item.swltonns;
  });

  // console.log(items);

  const { id } = useParams();
  useEffect(() => {
    const product_id = id;
    axios.get(`/api/view_challan/${product_id}`).then((res) => {
      if (res.data.status === 200) {
        // console.log(res.data.chalans);
        setproduct(res.data.chalans);
        setitemDetails(res.data.itemDetails);
        setverticalInput(res.data.chalanseqence);
      } else if (res.data.status === 404) {
        swal("Error", res.data.message, "error");
        navigate("/certificates/challan");
      }
      setLoading(false);
    });
  }, [id, navigate]);


  const handleInput = (e) => {
    e.persist();
    setproduct({ ...productInput, [e.target.name]: e.target.value });
  };
  if (loading) {
    swal({
      title: "Loading",
      text: "Please Wait!!!",
      timer: 1000,
      buttons: false,
    }).then(
      function () {},
      // handling the promise rejection
      function (dismiss) {
        if (dismiss === "timer") {
          //console.log('I was closed by the timer')
        }
      }
    );
  }

  const challanId = id;
  const handlePrint = () => {
    window.print();
  };
  return (
    <main>
      <Navbar/>
      <div className="downloadbutton">
        <button className="button">
          <a style={{ color: 'white',textDecoration: 'none' }}
            href={"https://cert.geekay.biz/backend/api/pdf/" + challanId}
            // href={"/api/pdf/" + challanId}
            target="_blank"
            rel="noreferrer"
          >
            Challan Download
          </a>
        </button>
        <button className="button">
          <a style={{ color: 'white',textDecoration: 'none' }}
            href={"/certificates/printchallan/" + challanId}
            target="_blank"
            rel="noreferrer"
          >
            Print Challan
          </a>
        </button>
      </div>
      <div class="border border-dark">
        <div className="mb-40 ml-40 mr-40 mt-10 border border-dark p-3">
          <section>
            {/* <header className='flex flex-col items-center justify-center mb-5'> */}
            <header className="flex flex-col mb-5">
              <div className="mainbox1">
                <div className="oxes1">
                  <img src={logo} className="logo" alt="logo" />
                </div>
                {/* <div className='flex item-center justify-between flex-wrap'> */}
                <div className="oxes7">
                  <div>
                    <h5 className="company">GeeKay Industries India</h5>
                    <p className="add-1">
                      17A, Sitafal Wadi, Mount Road, Mazgaon,
                    </p>
                    <p className="add-2"> Mumbai - 400 010</p>
                  </div>
                </div>
                <div className="oxes11">
             
                </div>
              </div>
              {/* <button onClick={handlePrint} className="btn btn-print">Print</button> */}
            </header>
          </section>

          <section>
            {/* <Box paddingLeft={10}> */}
            <div className="mainbox1">
              <div className="oxes1">
                <p>Memo No :</p>
              </div>
              <div className="oxes12">
                <p className="hi">{productInput.memo_no}</p>
              </div>
              <div className="oxes3">
                <p>Party Code:</p>
              </div>
              <div>
                <p className="hi">{productInput.party_code}</p>
              </div>
              <div className="oxes4">
                <p>Dated of Test:</p>
              </div>
              <div className="oxes14">
                <p className="hi">{productInput.date}</p>
              </div>
            </div>
            {/* </Box> */}
            <Box paddingLeft={0}>
              <div className="mainbox1">
                <div className="oxes15">
                  <p className="hi">Month of Test:</p>
                </div>
                <div className="oxes16">
                  <p className="hi">{productInput.month_of_test}</p>
                </div>
              </div>
            </Box>
          </section>

          <section>
            {/* <div className = "px-8 m-5"> */}

            <table class="table table-bordered">
              <thead>
                <tr>
                  <th scope="col">Distinguish Mark</th>
                  <th scope="col">S N</th>
                  <th scope="col">
                    Description/Dimension & Material of Gear/Device
                  </th>
                  <th scope="col">Nos. Tests</th>
                  <th scope="col">P.L. Tonns</th>
                  <th scope="col">SWL Tonns</th>
                </tr>
              </thead>
              <tbody>
                <tr></tr>
                <tr></tr>
                <tr>
                  {/* <td height="450px">{item1}</td>
                  <td>{item2}</td>
                  <td>{item3}</td>
                  <td>{item4}</td>
                  <td>{item5}</td>
                  <td>{item6}</td> */}
                  

                  <td height="450px">{itemDetails.map((post)=>{
                    const lines = post.descriptive.split('\n');
                    const numLines = lines.length;
                    if (numLines>4 && numLines<8) {
                      return(
                        <div style={{minHeight:"200px"}}  key={post.pcode}>{post.distin}<br /></div>);
                    } 
                    else if (numLines > 8 && numLines < 13) {
                       return(
                        <div style={{ minHeight:"230px" }}  key={post.pcode}>{post.distin}<br /></div>);
                    } else {
                      return(
                        <div style={{ minHeight:"130px" }}  key={post.pcode}>{post.distin}<br /></div>);
                    }
                  })}</td>
                  <td height="450px">{itemDetails.map((post)=>{
                    const lines = post.descriptive.split('\n');
                    const numLines = lines.length;
                    if (numLines>4 && numLines<8) {
                      return(
                        <div style={{minHeight:"200px"}}  key={post.pcode}>{post.sn}<br /></div>);
                    } 
                    else if (numLines > 8 && numLines < 13) {
                       return(
                        <div style={{ minHeight:"230px" }}  key={post.pcode}>{post.sn}<br /></div>);
                    } else {
                      return(
                        <div style={{ minHeight:"130px" }}  key={post.pcode}>{post.sn}<br /></div>);
                    }
                  })}</td>
                  <td height="450px">{itemDetails.map((post)=>{
                    const lines = post.descriptive.split('\n');
                    const numLines = lines.length;
                    const desc = post.descriptive;
                    console.log("fkbndsfkad");
                    console.log(desc);
                    if (numLines>4 && numLines<8) {
                      return(
                        //<div style={{minHeight:"200px"}}  key={post.pcode}>{post.descriptive}<br /></div>);
                        <div style={{minHeight:"200px"}}  key={post.pcode}>{lines.map((post)=>{
                          return(
                            <div>{post}<br/></div>
                          );
                        })}<br /></div>
                        
                        );
                    } 
                    else if (numLines > 8 && numLines < 13) {
                       return(
                        <div style={{ minHeight:"230px" }}  key={post.pcode}>{lines.map((post)=>{
                          return(
                            <div>{post}<br/></div>
                          );
                        })}<br /></div>);
                    } else {
                      return(
                        <div style={{ minHeight:"130px" }}  key={post.pcode}>{lines.map((post)=>{
                          return(
                            <div>{post}<br/></div>
                          );
                        })}<br /></div>);
                    }
                  })}</td>
                  <td height="450px">{itemDetails.map((post)=>{
                    const lines = post.descriptive.split('\n');
                    const numLines = lines.length;
                    if (numLines>4 && numLines<8) {
                      return(
                        <div style={{minHeight:"200px"}}  key={post.pcode}>{post.test}<br /></div>);
                    } 
                    else if (numLines > 8 && numLines < 13) {
                       return(
                        <div style={{ minHeight:"230px" }}  key={post.pcode}>{post.test}<br /></div>);
                    } else {
                      return(
                        <div style={{ minHeight:"130px" }}  key={post.pcode}>{post.test}<br /></div>);
                    }
                  })}</td>
                  <td height="450px">{itemDetails.map((post)=>{
                    const lines = post.descriptive.split('\n');
                    const numLines = lines.length;
                    
                    if (numLines>4 && numLines<8) {
                      return(
                        <div style={{minHeight:"200px"}}  key={post.pcode}>{post.pltonns}<br /></div>);
                    } 
                    else if (numLines > 8 && numLines < 13) {
                       return(
                        <div style={{ minHeight:"230px" }}  key={post.pcode}>{post.pltonns}<br /></div>);
                    } else {
                      return(
                        <div style={{ minHeight:"130px" }}  key={post.pcode}>{post.pltonns}<br /></div>);
                    }
                  })}</td>
                  <td height="450px">{itemDetails.map((post)=>{
                    const lines = post.descriptive.split('\n');
                    const numLines = lines.length;
                   
                    if (numLines>4 && numLines<8) {
                      return(
                        <div style={{minHeight:"200px"}}  key={post.pcode}>{post.swltonns}<br/>{post.swltonns2}<br /></div>);
                    } 
                    else if (numLines > 8 && numLines < 13) {
                       return(
                        <div style={{ minHeight:"230px" }}  key={post.pcode}>{post.swltonns}<br/>{post.swltonns2}<br /></div>);
                    } else {
                      return(
                        <div style={{ minHeight:"130px" }}  key={post.pcode}>{post.swltonns}<br/>{post.swltonns2}<br /></div>);
                    }
                  })}</td>
                </tr>
              </tbody>
            </table>
          </section>

          <section>
            <footer>
              {/* <div className = "px-12 ml-8 mr-8"> */}
              <div className="mainbox1">
                <div className="oxes1">
                  <p>Tested:</p>
                </div>
                <div className="oxes17">
                  <p className="hi">{productInput.tested}</p>
                </div>
                <div className="oxes2">
                  <b>
                    <p>Auth. Signature:___________________</p>
                  </b>
                </div>
              </div>
              {/* </div> */}
              {/* <div className='px-12 ml-8 mr-8'> */}
              <div className="mainbox1">
                <div className="oxes19">
                  <p className="hi">Party's Name:</p>
                </div>
                <div className="oxes20">
                  <p className="hi">{productInput.party_name}</p>
                </div>
              </div>
              <div className="mainbox1">
                <div className="oxes21">
                  <p className="hi">Remarks:</p>
                </div>
                <div className="oxes22">
                  <p className="hi">{productInput.remarks}</p>
                </div>
              </div>
            </footer>
          </section>
        </div>
      </div>
    </main>
  );
}

export default ViewChallan;
